<template><div><h1 id="spezifisches-dokument-pro-segment-erstellen" tabindex="-1"><a class="header-anchor" href="#spezifisches-dokument-pro-segment-erstellen"><span>Spezifisches Dokument pro Segment erstellen</span></a></h1>
<h2 id="ausgangslage" tabindex="-1"><a class="header-anchor" href="#ausgangslage"><span>Ausgangslage</span></a></h2>
<p>Wir möchten Segment-spezifische Dokumente generieren. Mit Hilfe von funtrade und einer Segmentierung mit zwei Segmenten ist es ein Kinderspiel, Briefe mit zwei verschiedenen Inhalten zu verschicken. Für dieses Beispiel nutzen wir dazu das Dokument <code v-pre>AdrExport</code>, in dem zwei unterschiedliche Elemente <code v-pre>BriefText1</code> verwendet werden. Ein Element hat kein Attribut und das andere hat das Attribut <code v-pre>DokumentCode=VIP</code> (siehe Attachments seg20240604-001 und seg20240604-002).</p>
<p><img src="@source/tutorial/i/segmentierung-mit-do/seg20240604-001.png" alt="seg20240604-001"></p>
<p><img src="@source/tutorial/i/segmentierung-mit-do/seg20240604-002.png" alt="seg20240604-002"></p>
<h3 id="segmentierung-erstellen" tabindex="-1"><a class="header-anchor" href="#segmentierung-erstellen"><span>Segmentierung erstellen</span></a></h3>
<p>Erstelle die Segmentierung <code v-pre>2023.PDFDemo</code> mit zwei Positionen, für die personalisierte Dokumente generiert werden sollen:</p>
<ul>
<li><code v-pre>1 NormalBrief</code> und</li>
<li><code v-pre>2 VIPBrief</code></li>
</ul>
<p>(siehe Attachments seg20240604-003 bis seg20240604-005).</p>
<p><img src="@source/tutorial/i/segmentierung-mit-do/seg20240604-003.png" alt="seg20240604-003">
<img src="@source/tutorial/i/segmentierung-mit-do/seg20240604-004.png" alt="seg20240604-004">
<img src="@source/tutorial/i/segmentierung-mit-do/seg20240604-005.png" alt="seg20240604-005"></p>
<div class="hint-container warning">
<p class="hint-container-title">Wichtig zu beachten</p>
<p>Die Exportdatei für <code v-pre>2 VIPBrief</code> muss denselben Namen haben wie der Dokumentencode im Dokument, also <code v-pre>VIP</code>.
Beim Erstellen der PDFs wird überprüft, ob der Name der Exportdatei einem Dokumentencode im Dokument entspricht. Falls ja, wird für das Segment das Element mit diesem Dokumentencode verwendet. Andernfalls wird das &quot;Standard&quot;-Element genutzt.</p>
</div>
<h3 id="pdf-erstellung" tabindex="-1"><a class="header-anchor" href="#pdf-erstellung"><span>PDF-Erstellung:</span></a></h3>
<p>Verwende den Dokumentensatz, der mit dem Dokument <code v-pre>AdrExport</code> arbeitet (siehe Attachment seg20240604-006).</p>
<p><img src="@source/tutorial/i/segmentierung-mit-do/seg20240604-006.png" alt="seg20240604-006"></p>
<p>Es werden zwei Dateien generiert (siehe Attachment seg20240604-007).</p>
<p><img src="@source/tutorial/i/segmentierung-mit-do/seg20240604-007.png" alt="seg20240604-007"></p>
<div class="hint-container tip">
<p class="hint-container-title">Tipp</p>
<p>Du findest die generierten Dokumente an verschiedenen Orten:</p>
<ul>
<li>im ZIP in &quot;Anhänge&quot;: das findest du im Kontextmenü, wenn du mit der rechten Maustaste auf die Segmentierung (im Beispiel <code v-pre>2023.PDFDemo</code>) klickst</li>
<li>im ZIP im Job, der die Dokumente generiert hat</li>
<li>als einzelnes Dokument in den Dokumenten der Person</li>
</ul>
</div>
<p>Der Inhalt beider Dateien entspricht den unterschiedlichen <code v-pre>BriefText1</code>-Elementen (siehe Attachments seg20240604-008 und seg20240604-009).
Durch diese Schritte kannst du sicherstellen, dass personalisierte Dokumente für verschiedene Segmente erstellt werden.</p>
<ul>
<li>
<p>ohne VIP:</p>
<p><img src="@source/tutorial/i/segmentierung-mit-do/seg20240604-008.png" alt="seg20240604-008"></p>
</li>
<li>
<p>mit VIP:</p>
<p><img src="@source/tutorial/i/segmentierung-mit-do/seg20240604-009.png" alt="seg20240604-009"></p>
</li>
</ul>
<h3 id="zusatz" tabindex="-1"><a class="header-anchor" href="#zusatz"><span>Zusatz:</span></a></h3>
<p>Für das Tutorial haben wir nur den einen Text verändert. Grundsätzlich kann aber für jedes Element im Dokument ein zweites Element mit Attribut <code v-pre>DokumentCode=VIP</code> hinzugefügt und so das ganze Dokument entsprechend angepasst werden.</p>
</div></template>


